// Module
var code = "<div>\n    <div class=\"flex-item\">\n        <p class=\"flex-horizonal-center flex-vertical-center\">{{'EMPTY_LIST'|translate}}</p>\n    </div>\n\n</div>\n";
// Exports
module.exports = code;